// extracted by mini-css-extract-plugin
export default {"dashboadToolbarPane":"Y4AvYCXIz8f5oECFmZWy"};